export default __webpack_public_path__ + "static/Rolvedon_final_fullsize-10b-aef7c7550be3889a549903f48a9d5312.png";